function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransitions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4B1A8"
    },
    d: "M323.833,36.062c0,0-79.342-31.171-155.222,12.821C92.731,92.874,56.279,183.385,24.834,255.824 c-31.445,72.44-10.206,147.607,49.578,183.277c59.784,35.67,98.467-13.379,180.987-13.52c82.52-0.141,105.06,12.726,172.29-33.764 c67.23-46.49,76.547-160.451,20.216-246.535C391.574,59.198,323.833,36.062,323.833,36.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M323.833,36.062c0,0-79.342-31.171-155.222,12.821 C92.731,92.874,56.279,183.385,24.834,255.824c-31.445,72.44-10.206,147.607,49.578,183.277 c59.784,35.67,98.467-13.379,180.987-13.52c82.52-0.141,105.06,12.726,172.29-33.764c67.23-46.49,76.547-160.451,20.216-246.535 C391.574,59.198,323.833,36.062,323.833,36.062z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Numbers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M120.987,472.434v-35.608c-0.036,0.035-0.435,0.142-1.196,0.318 c-0.763,0.178-1.621,0.354-2.578,0.532c-0.957,0.178-1.807,0.337-2.551,0.477c-0.744,0.143-1.134,0.213-1.169,0.213v-4.305 c0.602-0.142,1.302-0.337,2.1-0.585c0.797-0.247,1.612-0.549,2.445-0.903c0.832-0.354,1.629-0.797,2.392-1.329 c0.761-0.531,1.408-1.15,1.94-1.859h4.305v43.049H120.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M231.807,472.434v-4.039l10.948-17.06c0.814-1.275,1.568-2.462,2.259-3.561 c0.691-1.098,1.257-2.259,1.701-3.481c0.442-1.223,0.664-2.631,0.664-4.225c0-1.984-0.319-3.543-0.957-4.678 c-0.638-1.133-1.754-1.7-3.348-1.7c-1.347,0-2.392,0.372-3.136,1.116c-0.744,0.744-1.258,1.719-1.542,2.923 c-0.284,1.205-0.425,2.498-0.425,3.88v1.435h-5.687v-1.488c0-2.586,0.346-4.81,1.037-6.67c0.691-1.859,1.807-3.303,3.348-4.331 c1.541-1.027,3.587-1.541,6.139-1.541c3.472,0,6.059,0.983,7.759,2.949c1.701,1.967,2.551,4.686,2.551,8.158 c0,1.843-0.222,3.454-0.665,4.836c-0.443,1.382-1.019,2.676-1.727,3.88c-0.709,1.205-1.488,2.445-2.339,3.721l-9.885,15.094 h13.606v4.783H231.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.501,472.912c-2.339,0-4.288-0.443-5.847-1.329c-1.56-0.885-2.728-2.16-3.508-3.826 c-0.779-1.665-1.169-3.632-1.169-5.899v-1.435h5.634c0,0.143,0,0.293,0,0.452c0,0.159,0,0.328,0,0.505 c0.035,1.275,0.186,2.428,0.452,3.455c0.266,1.027,0.743,1.842,1.435,2.444c0.69,0.603,1.691,0.903,3.003,0.903 c1.382,0,2.427-0.327,3.136-0.983c0.708-0.655,1.186-1.585,1.435-2.79c0.248-1.204,0.372-2.586,0.372-4.146 c0-2.267-0.417-4.119-1.249-5.554c-0.833-1.435-2.294-2.223-4.385-2.365c-0.105-0.034-0.239-0.053-0.398-0.053 c-0.159,0-0.292,0-0.398,0v-5.686c0.107,0,0.23,0,0.372,0s0.266,0,0.372,0c2.02-0.071,3.472-0.602,4.358-1.595 c0.885-0.991,1.328-2.64,1.328-4.942c0-1.948-0.328-3.508-0.983-4.678c-0.655-1.169-1.958-1.754-3.906-1.754 c-1.949,0-3.242,0.647-3.88,1.94c-0.638,1.294-0.992,2.949-1.063,4.969c0,0.143,0,0.293,0,0.452s0,0.31,0,0.452h-5.634v-1.435 c0-2.303,0.39-4.27,1.169-5.899c0.779-1.629,1.958-2.887,3.535-3.773c1.576-0.885,3.534-1.328,5.872-1.328 c2.374,0,4.34,0.443,5.899,1.328c1.559,0.887,2.729,2.152,3.508,3.8c0.779,1.648,1.169,3.624,1.169,5.927 c0,2.586-0.558,4.659-1.674,6.218c-1.116,1.56-2.613,2.622-4.491,3.188c1.31,0.391,2.419,1.064,3.322,2.02 c0.903,0.957,1.603,2.171,2.099,3.641c0.496,1.471,0.744,3.181,0.744,5.129c0,2.551-0.355,4.775-1.063,6.67 c-0.709,1.897-1.843,3.367-3.401,4.411C360.107,472.39,358.052,472.912,355.501,472.912z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M382.542,212.43 v59.85h-72.53v-59.85h24.31v2.42c0,1.46,1.19,2.65,2.65,2.65c1.46,0,2.65-1.19,2.65-2.65v-2.42h13.31v2.42 c0,1.46,1.19,2.65,2.65,2.65s2.64-1.19,2.64-2.65v-2.42H382.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 314.394,
    y: 229.276,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.058,
    y: 229.276,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.722,
    y: 229.276,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.385,
    y: 229.276,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.049,
    y: 229.276,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 314.394,
    y: 243.319,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.058,
    y: 243.319,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.722,
    y: 243.319,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.385,
    y: 243.319,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.049,
    y: 243.319,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 314.394,
    y: 257.362,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.058,
    y: 257.362,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.722,
    y: 257.362,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.385,
    y: 257.362,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.049,
    y: 257.362,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.109,
    height: 9.109
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M339.622,205.74 v9.11c0,1.46-1.19,2.65-2.65,2.65c-1.46,0-2.65-1.19-2.65-2.65v-9.11c0-1.46,1.19-2.64,2.65-2.64 C338.432,203.1,339.622,204.28,339.622,205.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M358.222,205.74 v9.11c0,1.46-1.18,2.65-2.64,2.65s-2.65-1.19-2.65-2.65v-9.11c0-1.46,1.19-2.64,2.65-2.64S358.222,204.28,358.222,205.74z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.295,
    y: 157.558,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.678,
    height: 24.732
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.585,
    y: 144.917,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.678,
    height: 37.373
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.875,
    y: 128.979,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.678,
    height: 53.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.164,
    y: 117.987,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.678,
    height: 64.303
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Target"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 34.9007 350.0367)",
    style: {
      fill: "#D4B1A8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 439.982,
    cy: 132.889,
    rx: 53.111,
    ry: 53.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 34.9007 350.0367)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 439.982,
    cy: 132.889,
    rx: 42.531,
    ry: 42.531
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 34.9007 350.0367)",
    style: {
      fill: "#D4B1A8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 439.982,
    cy: 132.889,
    rx: 27.23,
    ry: 27.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 34.9007 350.0367)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 439.982,
    cy: 132.889,
    rx: 15.389,
    ry: 15.389
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M446.48,132.889 c0-3.589-2.909-6.498-6.498-6.498c-3.589,0-6.498,2.909-6.498,6.498c0,3.589,2.909,6.498,6.498,6.498 C443.571,139.387,446.48,136.478,446.48,132.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF"
    },
    x1: 437.341,
    y1: 132.889,
    x2: 346.325,
    y2: 132.889
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M438.695,134.177h-71.427v-2.575h71.427c0.711,0,1.288,0.577,1.288,1.288l0,0C439.982,133.6,439.406,134.177,438.695,134.177z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 360.921,123.731 361.318,124.191 368.784,131.592 346.449,131.592 338.457,123.731  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M338.457,141.749l7.992-7.594h22.335c-2.907,2.18-5.547,4.755-7.929,7.594H338.457z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Arrows"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M41.436,131.363l88.701-61.026l89.097,45.962 c2.254,1.162,4.895,1.319,7.272,0.434l53.998-20.149l-2.804,16.434l45.505-41.973l-61.876-1.9l12.88,10.576l-50.265,18.756 l-90.345-46.607c-2.947-1.52-6.493-1.296-9.227,0.584l-93.14,64.081"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "99.711,250.9 276.405,186.852  273.358,203.243 319.481,161.949 257.64,159.131 270.362,169.897 93.669,233.944  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "16.257,385.767 235.736,307.562  232.689,323.952 278.812,282.659 216.971,279.841 229.694,290.607 10.215,368.812  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stairs"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 64.915,477.741 64.915,422.116 123.186,422.116 123.186,399.175 181.458,399.175 181.458,376.223 239.72,376.223 239.72,353.282  297.992,353.282 297.992,330.33 356.263,330.33 356.263,307.389 414.526,307.389 414.526,284.437 472.798,284.437  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 181.458,
    y1: 406.349,
    x2: 181.458,
    y2: 478.625
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 298.441,
    y1: 363.132,
    x2: 298.441,
    y2: 478.625
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 415.425,
    y1: 324.385,
    x2: 415.425,
    y2: 478.625
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M69.819,387.07 l-0.419,4.834l3.105,6.532c0,0,3.126,3.243,2.583,4.37c-0.543,1.128-1.446,1.561-2.287,1.503 c-0.84-0.058-11.197-4.873-13.874-6.163s-3.465-7.226-3.981-9.038c-0.516-1.812-5.485-6.637-4.273-9.873 c1.212-3.236,7.253-6.404,7.253-6.404L69.819,387.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M102.966,293.122l2.538,36.156l-45.803,40.588l-4.548,4.755c0,0,5.578,9.298,7.923,11.336c2.345,2.037,6.136,2.956,6.136,2.956 s1.682-1.609,2.619-4.182c0.937-2.573,1.975-6.609,1.975-6.609s52.639-34.068,53.84-35.304 c1.201-1.236,6.402-40.762,6.402-40.762L102.966,293.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M121.057,342.819 c0,0-25.741,6.349-31.46,6.92"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 100.008,
    y1: 345.078,
    x2: 90.161,
    y2: 346.685
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M148.867,383.661l9.191,6.53c0,0,6.22,3.524,7.152,3.627c0.933,0.104,1.952,0.846,1.831,1.935 c-0.121,1.088-2.194,2.747-5.839,2.972c-3.645,0.225-13.976-1.709-14.754-1.796c-0.777-0.086-10.85-4.353-13.596-5.13 c-2.747-0.777-3.3-4.301-2.747-6.444c0.553-2.142,4.266-7.239,4.266-7.239L148.867,383.661z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M94.986,259.649c0,0-3.605,15.063-3.435,20.495c0.17,5.431,7.596,13.408,9.166,14.935c1.57,1.527,9.42,3.945,9.951,4.391 c0.53,0.445,43.791,18.199,43.791,18.199s-2.906,7.023-4.985,11.818c-2.079,4.795-13.023,44.172-13.023,44.172l-2.397,2.44 l-1.379,5.453l19.111,4.164c0,0,1.723-3.784,2.041-4.909c0.318-1.124-0.255-6.407-0.149-7.362 c0.106-0.955,23.566-52.087,24.733-55.63c1.167-3.543,4.985-10.078,3.669-12.157c-1.315-2.079-42.031-27.089-42.031-27.089 l0.572-8.635C140.622,269.935,109.329,268.007,94.986,259.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M121.592,274.201 c0,0,6.98-1.931,8.104-1.613c1.124,0.318,7.68,3.945,7.68,3.945"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M119.025,274.689 c0,0-2.44,1.082-4.201,3.013"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M121.847,271.91 c0,0-7.553,0.128-11.393,3.374"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M171.155,310.052 c0,0-9.95,6.047-14.193,7.703"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M174.78,248.584 l4.918-0.087l5.474-0.817c0,0,9.558,2.328,9.611,3.284c0.052,0.956-0.156,1.408-0.382,2.016 c-0.226,0.608-2.988,8.377-3.718,9.246c-0.73,0.869-1.043,0.834-1.981,0.73c-0.938-0.104-5.266-1.06-5.266-1.06 s-5.248-1.216-6.465-1.668c-1.217-0.452-3.58-1.981-3.58-1.981l-1.981-0.695L174.78,248.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M177.543,250.791c0,0,4.559-4.105,5.237-4.505c0.678-0.4,4.51,0.23,5.588,0.508c1.077,0.278,2.65,1.354,2.268,1.945 c-0.382,0.591-1.448,6.987-1.987,7.561c-0.539,0.574-1.686,0.921-2.572,0.348c-0.886-0.573-0.372-6.198-0.372-6.198 s-0.758,4.964-2.426,5.729c-1.668,0.765-4.727-0.208-4.727-0.208"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 185.155,254.961 183.818,259.879 185.191,260.349  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 176.205,248.584 172.07,258.733 142.265,254.791 147.72,235.605  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 170.296,
    y1: 246.186,
    x2: 166.613,
    y2: 257.969
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M131.266,173.25 c0,0-20.612,15.732-22.589,24.664c-1.977,8.932-7.801,28.418-7.801,28.418s-7.971,32.482-7.862,34.042s4.976,3.368,7.124,4.311 c2.148,0.942,16.689,5.654,25.59,6.642s15.051,0.122,15.051,0.122s2.488-2.117,2.627-3.369c0.139-1.252,1.313-11.821,1.359-12.239 c0.046-0.417,6.409-39.976,5.837-50.035c-0.573-10.059,0.277-13.907,0.277-13.907l4.975-5.501l-7.201-3.615L131.266,173.25z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 155.852,186.398 153.998,194.217 151.696,190.864  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M162.678,141.4 c0,0,2.952,3.847,3.153,9.642c0.201,5.795,1.314,7.185,2.519,7.742c1.205,0.556,1.762,1.885,0.603,3.446 c-1.159,1.561-2.735,3.075-2.735,3.075s-1.452,9.272-2.363,11.141c-0.912,1.87-3.029,0.649-5.934,0.186 c-2.905-0.463-4.11-1.02-4.11-1.02l-3.569,8.051l-17.122-11.897l2.858-7.989c0,0-2.071-2.905-0.882-12.346 C136.286,141.989,153.994,138.465,162.678,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M165.827,156.059 c0.007,2.473-0.739,4.48-1.666,4.483c-0.927,0.003-1.685-2-1.692-4.473c-0.007-2.473,0.739-4.48,1.666-4.483 C165.062,151.584,165.819,153.586,165.827,156.059z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 162.468,
    y1: 156.069,
    x2: 145.218,
    y2: 155.37
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M161.211,149.543 c0,0,2.488,0.417,3.554,0.958"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 162.711,
    y1: 167.731,
    x2: 164.519,
    y2: 167.932
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M145.218,155.37 c0,0,4.358,0.061,3.94-1.252s-1.855-2.318-1.036-3.353c0.819-1.035,4.326-2.195,4.404-4.157c0.077-1.962-0.958-2.781-0.618-3.307 c0.34-0.526,6.336,1.266,7.556,0.416c1.221-0.85,0.309-1.514,0.309-1.514s7.124,3.044,8.329,1.066 c1.205-1.978,0.432-7.695-7.882-11.434c-8.314-3.739-24.307-4.247-28.386-0.477c-4.079,3.771-7.571,9.859-7.4,15.932 s4.668,13.752,6.059,16.441c1.391,2.689,4.234,4.975,6.877,4.002c2.642-0.974,5.037-6.058,5.516-9.102 C143.364,155.587,145.218,155.37,145.218,155.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M145.867,157.132c0,0-0.217-4.389-2.519-5.207c-2.303-0.819-4.713,1.87-3.832,5.347c0.881,3.477,4.188,4.126,5.671,3.445"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M153.811,175.612c0,0-2.457-0.695-4.265-2.163c-1.808-1.468-2.411-2.38-2.411-2.38l3.926,10.291L153.811,175.612z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M131.978,222.601 c1.041-0.015,2.089-0.081,3.124-0.213"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M117.734,220.319 c0,0,5.281,1.814,11.46,2.21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M130.025,229.774 c1.147,0.466,2.263,0.863,3.285,1.145"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M118.074,223.595 c0,0,4.775,2.935,9.693,5.197"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M116.264,240.662 c1.073,1.036,2.148,1.873,3.172,2.372"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M106.67,227.397 c0,0,3.224,5.813,7.04,10.463"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4B1A8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M145.808,188.098 l3.122,8.653l1.423,13.814c0,0,2.147-6.66,2.688-8.993c0.541-2.333-0.881-4.744-0.881-4.744l-1.283-4.929l-0.633,3.168 l-3.014-7.092L145.808,188.098z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 132.286,169.139 129.551,173.482 145.128,191.684 152.869,182.829  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4B1A8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M150.353,210.566 c0,0-12.406,29.314-14.661,34.414c-2.256,5.099-8.22,13.166-8.22,13.166l0.542,10.338l10.863-6.537c0,0,7.431-20.012,9.531-32.59 C150.508,216.778,150.353,210.566,150.353,210.566z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M135.224,187.335c0,0-4.174-2.678-7.387-2.16c-3.213,0.519-10.677,4.605-13.987,8.448c-3.31,3.843-29.749,17.982-30.78,20.013 c-1.031,2.031-17.681,43.523-17.681,43.523l10.273,4.753l9.547-14.703l13.196-23.695l32.224-10.989"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 66.876,
    y1: 253.075,
    x2: 77.86,
    y2: 257.89
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M75.663,261.913 l1.009,9.021l-1.675,4.061c0,0,0.497,2.746,0.428,3.538c-0.069,0.792,0.292,1.223-0.905,0.873 c-1.198-0.35-2.531-3.016-2.531-3.016l-1.843,3.524c0,0-0.58,0.318-2.29-0.507c-1.709-0.825-2.188-3.078-2.188-3.078 s-5.208-3.311-5.713-4.921s0.028-4.543,0.028-4.543l5.407-9.708L75.663,261.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M59.983,266.867 c0,0-3.345,0.322-3.951,1.283c-0.606,0.96-3.317,6.344-3.317,6.344l2.133,1.599c0,0,1.412-3.163,2.387-4.828 c0.974-1.666,2.516-1.378,2.516-1.378L59.983,266.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M73.495,272.256 l-1.194,2.887c0,0,1.853,1.068,1.353,2.223c-0.5,1.154-2.912,6.625-2.912,6.625l2.414,1.193c0,0,3.347-4.7,3.298-7.314 C76.406,275.255,74.861,273.143,73.495,272.256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M43.097,267.936l41.724,24.633c0,0,2.699,2.624,1.719,4.58c-0.979,1.956-16.427,35.969-17.077,36.798s-1.355,1.846-4.094,1.453 c-2.739-0.393-43.616-27.225-44.07-27.765c-0.454-0.54-2.245-2.083-1.211-4.227c1.035-2.144,18.155-32.813,18.594-34.316 C39.121,267.589,41.861,267.982,43.097,267.936z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 31.135,
    y1: 285.843,
    x2: 72.428,
    y2: 310.554
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M84.968,294.854 c0,0-2.034-1.41-3.687,0.757c-1.653,2.167-17.279,34.7-17.476,36.07c-0.197,1.37,0.633,2.02,1.759,2.349"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitions);
export default __webpack_public_path__ + "static/media/Transitions.a65fff0dacee1408005adc705610ddfd.svg";
export { ForwardRef as ReactComponent };